module.exports = __webpack_public_path__ + "img/loading-2.96a335de.gif";